import { useEffect, useState } from 'react'
import { motion, useMotionValueEvent } from 'framer-motion'
import { useScroll } from 'framer-motion'
import { Button, Col, Grid, Row } from 'antd'
import { UpOutlined } from '@ant-design/icons'
import Introduction from '../../components/v2/Introduction'
import Intro2 from '../../components/v2/Intro2'
import Rule from '../../components/v2/Rule'
import Reward from '../../components/v2/Reward'
import TimeLine from '../../components/v2/Timeline'
import './styles.css'

export default function Home() {
    const { scrollY } = useScroll()
    const [arrLeft, setArrLeft] = useState(['translateX(-10rem)', 'translateX(0)'])
    const [arrRight, setArrRight] = useState(['translateX(10rem)', 'translateX(0)'])

    useMotionValueEvent(scrollY, 'change', (latest) => {
        var human = document.getElementsByClassName('human')[0] as HTMLElement
        var header = document.getElementById('header') as HTMLElement
        var frame1 = document.getElementById('frame1') as HTMLElement

        if (latest > 0) {
            human.style.zIndex = '-1'
            human.style.position = 'fixed'
            header.style.opacity = window.innerWidth > 768 ? '.9' : '1'
            frame1.style.height = '55vh'

            if (latest > 10) {
                human.style.width = '100vw'
                human.style.height = 'auto'
                human.style.opacity = '.1'
                human.style.marginTop = '-10rem'
                human.style.zIndex = '-1'
            } else {
                human.style.width = ''
                human.style.height = ''
                human.style.opacity = ''
                human.style.marginTop = '0'
                frame1.style.height = '100vh'
            }
        } else {
            human.style.opacity = '.8'
            human.style.width = 'auto'
            human.style.height = ''
            human.style.opacity = ''
            human.style.marginTop = '0'
            header.style.opacity = '0'
            frame1.style.height = '100vh'
            if (window.innerWidth < 768) {
                human.style.height = 'auto'
                human.style.width = '100vw'
            }
        }
    })

    const [countdown, setCountdown] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    })
    const [isTimeUp, setIsTimeUp] = useState(false)
    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date()
            const targetDate = new Date('2023-10-28T00:00:00')
            const diff = targetDate.getTime() - now.getTime()
            if (diff <= 0) {
                setIsTimeUp(true)
                return
            } else {
                const days = Math.floor(diff / (1000 * 60 * 60 * 24))
                const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
                const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
                const seconds = Math.floor((diff % (1000 * 60)) / 1000)
                setCountdown({ days, hours, minutes, seconds })
            }
        }, 1000)
        return () => clearInterval(interval)
    }, [])

    const fontStyle = {
        fontFamily: 'Conthrax',
        color: 'rgba(220, 220, 220, 0.82)',
        userSelect: 'none' as 'none',
        marginRight: '1rem',
        fontSize: window.innerWidth > 768 ? '' : '.8rem'
    }
    return (
        <>
            <Row
                id="header"
                style={{
                    opacity: '0',
                    position: 'fixed',
                    color: 'white',
                    zIndex: 999,
                    width: '100%',
                    backgroundColor: 'black',
                    height: window.innerWidth > 768 ? '4rem' : '20vh',
                    transition: 'all .5s ease-in-out',
                    display: 'flex',
                    alignItems: 'center'
                }}
                gutter={[0, 0]}
            >
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }}>
                    <h2
                        style={{
                            fontFamily: 'Conthrax',
                            fontSize: '1.5rem',
                            color: 'white',
                            userSelect: 'none' as 'none',
                            marginLeft: window.innerWidth > 768 ? '2rem' : '0',
                            textAlign: window.innerWidth > 768 ? 'left' : 'center',
                            height: '100%'
                        }}
                    >
                        SKILLCETERA
                    </h2>
                </Col>
                <Col
                    // span={16}
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 16 }}
                    style={{
                        textAlign: window.innerWidth < 768 ? 'center' : 'right'
                    }}
                >
                    {isTimeUp ? (
                        <Button
                            style={{
                                marginRight: window.innerWidth > 768 ? '2rem' : '0',
                                border: '1px dashed white',
                                fontFamily: 'Conthrax',
                                fontSize: window.innerWidth > 768 ? '1rem' : '.7rem'
                            }}
                            type="dashed"
                        >
                            Time's up
                        </Button>
                    ) : (
                        <>
                            <span style={fontStyle}>
                                Còn {countdown.hours + countdown.days * 24} giờ : {countdown.minutes} phút :
                                <div
                                    style={{
                                        display: 'inline-block',
                                        width: '4.5rem'
                                    }}
                                >
                                    {countdown.seconds} giây
                                </div>
                            </span>
                            <Button
                                style={{
                                    marginRight: window.innerWidth > 768 ? '2rem' : '0',
                                    border: '1px dashed white',
                                    fontFamily: 'Conthrax',
                                    fontSize: window.innerWidth > 768 ? '1rem' : '.7rem'
                                }}
                                type="dashed"
                                onClick={() => {
                                    // open link
                                    window.open('https://docs.google.com/forms/d/e/1FAIpQLSeZqK79jHYEwh43oCGnFuZ2U4Dkc4lUlV6LmLzQvLo-bsDPng/viewform')
                                }}
                            >
                                Đăng ký
                            </Button>
                        </>
                    )}
                </Col>
            </Row>
            {scrollY.get() > 100 && (
                <motion.div
                    style={{
                        position: 'fixed',
                        bottom: '1rem',
                        right: '1rem',
                        height: '3rem',
                        width: '3rem',
                        borderRadius: '50%',
                        backgroundColor: 'black',
                        opacity: '.2',
                        cursor: 'pointer',
                        zIndex: 999,
                        boxShadow: '0 0 .5rem 0 white'
                    }}
                    initial={{ opacity: 0, scale: 0.5 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{
                        duration: 0.8,
                        delay: 0.5,
                        ease: [0, 0.71, 0.2, 1.01]
                    }}
                    onClick={() => {
                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                        })
                    }}
                >
                    <UpOutlined
                        style={{
                            fontSize: '1.5rem',
                            color: 'white',
                            marginTop: '.75rem',
                            marginLeft: '.75rem'
                        }}
                    />
                </motion.div>
            )}
            <motion.div
                initial={{ scale: 0 }}
                animate={{ rotate: 180, scale: 1 }}
                transition={{
                    type: 'spring',
                    stiffness: 260,
                    damping: 20
                }}
            />
            <motion.div
                animate={{
                    opacity: [0, 0.6]
                }}
                transition={{
                    duration: 2
                }}
            >
                <img
                    src={
                        scrollY.get() > 0
                            ? 'https://pub-d6d2c41035bd487385771fe778786b8a.r2.dev/v2/BG2.webp'
                            : 'https://pub-d6d2c41035bd487385771fe778786b8a.r2.dev/v2/BG1.webp'
                    }
                    alt="bg"
                    className="bg1"
                />
            </motion.div>
            <motion.div
                animate={{
                    opacity: [0, 0.8],
                    borderRadius: ['20%', '20%', '50%', '50%', '20%']
                }}
                transition={{
                    duration: 1
                }}
            >
                <img
                    src="https://pub-d6d2c41035bd487385771fe778786b8a.r2.dev/v2/human.webp"
                    alt="human"
                    className="human"
                />
            </motion.div>
            <motion.div
                animate={{
                    opacity: [0, 0.8],
                    transform: arrLeft
                }}
                transition={{
                    duration: 0.5
                }}
            >
                <img src="v2/left.png" alt="left" className="left" />
            </motion.div>
            <motion.div
                animate={{
                    opacity: [0, 0.8],
                    transform: arrRight
                }}
                transition={{
                    duration: 0.5
                }}
            >
                <img src="v2/right.png" alt="right" className="right" />
            </motion.div>

            {/* ************ */}
            <div
                style={{
                    position: 'absolute'
                }}
            >
                <div id="frame1" style={{ transition: 'all 1s', height: '100vh' }}></div>
                <Introduction />
                <Intro2 />
                <Rule />
                <Reward />
                <TimeLine />
                <Row>
                    <Col span={24} style={{ textAlign: 'center', lineHeight: '2rem' }}>
                        <div
                            style={{
                                fontFamily: 'Readex Pro',
                                color: 'rgba(220, 220, 220, 0.82)',
                                userSelect: 'none' as 'none',
                                marginTop: '1.2rem',
                                marginBottom: '1.2rem',
                                fontSize: window.innerWidth > 768 ? '' : '.8rem'
                            }}
                        >
                            Thông tin liên hệ:
                            <br />
                            Email: skillcetera@gmail.com
                            <span style={{ color: 'white' }}></span>
                            <br />
                            Điện thoại: 0787 727 888 (Mr. Hảo)
                            <br />
                            0832 110 278 (Ms. Trang)
                            <br />
                            0825 497 013 (Liên hệ nhà tài trợ - Ms. Phương)
                            <br />
                            <a href="https://www.facebook.com/skillcetera">Skillcetera Fanpage</a>
                        </div>
                    </Col>
                </Row>
                <Row
                    justify={'center'}
                    style={{
                        marginTop: '-2rem'
                    }}
                >
                    <div
                        style={{
                            height: window.innerWidth > 768 ? '6rem' : '3rem',
                            backgroundColor: 'transparent',
                            width: '100vw',
                            position: 'relative',
                            top: window.innerWidth > 768 ? '8rem' : '3rem'
                        }}
                    />
                    <img
                        src="v2/logos-sponsor.png"
                        alt="sponsor"
                        style={{
                            width: window.innerWidth > 768 ? '80vw' : '100vw',
                            userSelect: 'none'
                        }}
                    />
                </Row>
                <div style={{
                    backgroundColor: '#010a1b',
                    borderTop: '1px solid #ffffff15',
                    width: '100vw',
                    padding: '1.5rem 2rem',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '0.3rem',
                    fontSize: '0.8rem',
                    color: '#ffffff55',
                    fontFamily: 'Readex Pro'
                }}>
                    <span>© 2023 Skillcetera · FPT University. All rights reserved.</span>
                    <span>Built by <a href="https://duckdev.work" target="_blank" rel="noopener" style={{ color: '#6eb4ff', textDecoration: 'none' }}>TienNT</a></span>
                </div>
            </div>
        </>
    )
}

// Thông tin liên hệ:
// Email: skillcetera@gmail.com
// Điện thoại: 0787 727 888 (Mr. Hảo)
// 0832 110 278 (Ms. Trang)
// 0825 497 013 (Liên hệ nhà tài trợ - Ms. Phương)
